import { Chip, Stack, Typography } from "@mui/material";
import * as React from "react";
import { useBadges } from "../../../../hooks/useBadges";
import { generateBorder } from "../../../../lib/generateBorder";
import { generateRadius } from "../../../../lib/generateRadius";
import { TagsFilterProps } from "../../../../utils/interfaces/core/TagsFilterProps";

const TagsFilter: React.FC<TagsFilterProps> = ({
  tagHeight = "32px",
  tagPadding = { Left: "12px", Right: "12px" },
  tagRadius = {
    TopLeft: "16px",
    TopRight: "16px",
    BottomLeft: "16px",
    BottomRight: "16px",
  },
  // tagBorderSize = 2,
  tagFontSize = "13px",
  tagBorder = { width: "2px", color: "#00000000" },
  tagBgColor = "#00000010",
  tagTextColor = "#000000",
  tagActiveBorder = { width: "2px" },
  tagActiveBgColor = "#FFFFFF",
  tagActiveTextColor = "#000000",

  /**
   * FOR EDITION
   */
  onChange,
  urlParams = {},
}) => {
  const { badges } = useBadges();

  const [value, setValue] = React.useState<string[]>(urlParams.t ?? []);

  React.useEffect(() => {
    if (urlParams.t) {
      setValue(urlParams.t);
    }
  }, [urlParams]);

  const handleClick = async (index: string) => {
    try {
      const newValue = value.includes(index)
        ? value.filter((v) => v !== index)
        : [...value, index];

      setValue(newValue);

      if (onChange) await onChange({ t: newValue });
    } catch (error) {
      console.error("ERROR_UPDATE_TAGS =>", error);
    }
  };

  if (badges.length === 0) {
    return <Typography color="GrayText">{"Il n'y a aucun badge"}</Typography>;
  }

  return (
    <Stack
      sx={{
        gap: "8px",

        "& .MuiChip-root": {
          height: tagHeight,
          borderRadius: generateRadius(tagRadius),
          border: generateBorder(tagBorder),
          bgcolor: tagBgColor,
          cursor: "pointer",

          "& .MuiChip-label": {
            padding: tagPadding,
            fontSize: tagFontSize,
            fontFamily: "inherit",
            color: tagTextColor,
          },

          "&.SelectedTag, &:hover": {
            border: generateBorder(tagActiveBorder),
            bgcolor: tagActiveBgColor,

            "& .MuiChip-label": {
              color: tagActiveTextColor,
            },
          },
        },
      }}
      direction="row"
      flexWrap="wrap"
    >
      {badges.map((tag) => (
        <Chip
          onClick={() => {
            handleClick(tag.id);
          }}
          key={tag.id}
          label={tag.name}
          className={`${value.includes(tag.id) ? "SelectedTag" : ""}`}
        />
      ))}
    </Stack>
  );
};

export default TagsFilter;
